import React from "react";
import { Button } from "react-bootstrap";
import { todayIsoDate } from "./attendanceCrud";

/**
 * The date control both day-scoped tabs carry, in the portal's own reporting
 * idiom — a native `<input type="date">` in a `.form-control` under its own
 * `<label>`, exactly as `Reporting/Components/AttendanceReport/
 * AttendanceReportForm.js` does it. No new dependency, and the native picker
 * is already what staff see elsewhere.
 *
 * It sits in the card *body*, in a `form-group row` of `col-lg-6` columns, not
 * in the `card-toolbar`. A toolbar holds actions — Edit Batch puts Back and
 * Save there — while a labelled field belongs in the form grid with every
 * other labelled field in the portal. Today and Refresh act on this one field,
 * so they stay beside it, bottom-aligned to the input by `align-items-end`.
 *
 * The label above it is deliberate, and is NOT the filter-bar idiom the class
 * filters use (caption below, `<b>Filter</b> by X` — see `BadgeFilters.js`).
 * This is not a filter: it does not narrow rows already on screen, it is the
 * parameter the day's data is fetched *for*, and an empty value has no
 * meaning here the way "All" does in a filter. Every other date field in the
 * portal — `AttendanceReportForm.js`'s Start Date and End Date above all,
 * which this control was copied from — is labelled above, and a date input
 * shows no placeholder of its own to hint at what it wants.
 *
 * "Today" is a shortcut, not a separate mode: it just sets the date, so there
 * is only ever one piece of state to reason about.
 */
export function KioskDayPicker({ date, setDate, onRefresh, isLoading, label }) {
  const today = todayIsoDate();
  return (
    <form
      className="form form-label-right zr-no-print"
      onSubmit={(event) => event.preventDefault()}
    >
      <div className="form-group row align-items-end">
        <div className="col-lg-6">
          <label htmlFor="zr-kiosk-date">{label}</label>
          <input
            id="zr-kiosk-date"
            type="date"
            className="form-control"
            value={date}
            onChange={(event) => setDate(event.target.value)}
          />
        </div>
        <div className="col-lg-6">
          <Button
            className="btn btn-light font-weight-bolder font-size-sm mr-2"
            disabled={date === today}
            onClick={() => setDate(today)}
          >
            Today
          </Button>
          <Button
            className="btn btn-light-primary font-weight-bolder font-size-sm"
            disabled={isLoading}
            onClick={onRefresh}
          >
            {isLoading ? "Loading…" : "Refresh"}
          </Button>
        </div>
      </div>
    </form>
  );
}
